module.exports = __webpack_public_path__ + "media/iconic/arrow-thick-3e328cd1.svg";